import { observable, action, runInAction } from "mobx";

import BaseSearchBarViewStore from "./BaseSearchBarViewStore";
import { getCurrentCulture } from "@utils";
import { LazyImportWithLoadFailHandle as lazy } from "@lib/lazy-import-with-guard/LazyImportWithGuard";
import { redirectPreserveSearchParams } from "@state";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

class SearchBarViewStore extends BaseSearchBarViewStore {
	@observable public persistentTerm: string;
	constructor() {
		super({
			onTermChange: (val) => (this.persistentTerm = val),
		});

		this.onSubmit = this.onSubmit.bind(this);
	}

	@action.bound
	onTermChange(term: SearchBarViewStore["persistentTerm"]) {
		this.searchTerm = term;
	}

	@action.bound
	async validate() {
		const isValid = (await lazy(loadFailPath, () => import("xregexp")))
			.default("^[\\p{L}0-9-. ]{3,30}$")
			.test(this.searchTerm);

		runInAction(() => {
			this.displayValidationPopup = !isValid;
		});

		return isValid;
	}

	async onSubmit(
		{
			event,
			period,
		}: {
			event: { preventDefault: () => void; stopPropagation: () => void };
			period: string;
		},
		submitFn?: (() => void) | null
	) {
		event.preventDefault();
		event.stopPropagation();

		if (this.trimSearchTerm === "") {
			return;
		}

		const isValid = await this.validate();

		if (!isValid) {
			return;
		}

		runInAction(() => {
			this.persistentTerm = this.trimSearchTerm;

			if (submitFn != null) {
				submitFn();
			} else {
				redirectPreserveSearchParams(
					`/${getCurrentCulture()}/search/${period}/${
						this.persistentTerm
					}`
				);
			}
		});
	}
}

export default SearchBarViewStore;
